import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { endpoints } from '../../mps/mps-endpoints';
import { MpsApiService } from '../../mps/services/mps-api.service';
import { GenericApiResponse } from '../interfaces/responses';
import { Affiliate } from '../models/affiliate.model';

@Injectable({
  providedIn: 'root'
})
export class AffiliatesService {
  private readonly _apiService = inject(MpsApiService);

  getAll(): Observable<Affiliate[]> {
    return this._apiService.get<GenericApiResponse<{ affiliates: unknown[] }>>(`${endpoints.affiliates}`).pipe(
      map((res) =>
        res.data.affiliates.map((affiliate) => new Affiliate(affiliate)),
      ),
    );
  }

  get(id: string): Observable<Affiliate> {
    return this._apiService.get<GenericApiResponse<unknown>>(`${endpoints.affiliates}/${id}`).pipe(
      map((res) => new Affiliate(res.data)),
    );
  }

  add(affiliate: Affiliate): Observable<Affiliate> {
    return this._apiService.post<Affiliate, GenericApiResponse<unknown>>(endpoints.affiliates, affiliate).pipe(
      map((res) => new Affiliate(res.data)),
    );
  }

  update(affiliate: Affiliate): Observable<Affiliate> {
    return this._apiService.patch<Affiliate>(`${endpoints.affiliates}/${affiliate.id}`, affiliate)
      .pipe(
        map((res: unknown) => new Affiliate((res as { data: unknown }).data)),
      );
  }
}

